import axiosInstance from "../../config/axios/axios.config";

export async function fetchNationData() {
  let url = `/widgets/all/metro/data/national`;
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    if (error?.flag === "WidgetError") {
      return null;
    }
    throw new Error(`Failed fetch data. fetchNationData with error: ${error}`);
  }
}
